module.exports = __webpack_public_path__ + "img/LOGO-LULUU_NEW.c29aebbb.png";